import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const DatenschutzSection = () => {
  return (
    <Box
      id="datenschutz"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white',
      }}
    >
     <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1200px',
          px: 2,
          mx: 'auto'
        }}
      >
        <AnimatedElement>
          {/* Überschrift */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 500,
                color: '#000',
                mb: 2
              }}
            >
              DATENSCHUTZ
            </Typography>
            <Box 
              sx={{
                height: '4px', 
                width: '100px', 
                backgroundColor: 'rgb(58, 123, 62)', 
                mx: 'auto'
              }}
            />
          </Box>
        </AnimatedElement>

        <AnimatedElement>
          {/* Hauptinhalt */}
          <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.7,
                color: '#000',
                textAlign: 'left',
                '& h2': {
                  fontSize: { xs: '1.4rem', md: '1.6rem' },
                  fontWeight: 500,
                  marginTop: 4,
                  marginBottom: 2,
                  color: '#000'
                },
                '& h3': {
                  fontSize: { xs: '1.2rem', md: '1.4rem' },
                  fontWeight: 500,
                  marginTop: 3,
                  marginBottom: 1.5,
                  color: '#000'
                },
                '& p': {
                  marginBottom: 2
                },
                '& .contact-info': {
                  backgroundColor: '#f8f9fa',
                  padding: 3,
                  borderRadius: '8px',
                  marginBottom: 3,
                  borderLeft: '4px solid rgb(58, 123, 62)'
                }
              }}
            >
              
              <p>
                Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
              </p>
              
              <p>
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
              </p>
              
              <p>
                Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
              </p>

              <h2>Auskunft, Löschung, Sperrung</h2>
              
              <p>
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im Impressum angegeben Adresse des Webseitenbetreibers an uns wenden.
              </p>

              <h2>Kontakt</h2>
              <div className="contact-info">
                <p style={{ marginBottom: '0.5rem' }}>
                  <strong>Corps Guestphalia Berlin</strong>
                </p>
                <p style={{ marginBottom: '0.5rem' }}>
                  Schwendenerstraße 13<br />
                  14195 Berlin-Dahlem<br />
                  Deutschland
                </p>
                <p style={{ marginBottom: '0.5rem' }}>
                  <strong>Telefon:</strong> 030 - 83 227 866<br />
                  <strong>E-Mail:</strong> adh@guestphalia-berlin.de
                </p>
              </div>

              <p style={{ marginTop: 4, fontSize: '0.9rem', color: '#666', textAlign: 'center' }}>
                Stand: Dezember 2025
              </p>
            </Typography>
          </Box>
        </AnimatedElement>
      </Container>
    </Box>
  );
};

export default DatenschutzSection;
